import React from 'react';
import Axios from 'axios';

class AddLeague extends React.Component {

  constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit(e) {

		var _this = this;
		e.preventDefault();

		var league = {};
		league.name = e.target.elements[0].value;

		Axios.post('/api/leagues/', {
			league: league
		})
		.then(function(response) {
			//console.log(response);
			const path = '/admsafe/leagues';
			_this.props.history.push(path);

			_this.props.reloadLeagues();
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	render() {
		console.log("AddLeague: render");

		return (
      <div className="col-md-12 nopadding-left">
				<h3>Ajout d'une Ligue</h3>
        <form className="form" onSubmit={this.handleSubmit}>

					<div className="row nopadding-left">
					<div className="col-md-5 nopadding-left">
						<label htmlFor="leagueName" className="labelSmallMarginBottom">Entrer un nom pour votre ligue*</label>
						<input type="text" className="form-control" id="leagueName" placeholder="Nom de la Ligue"/>
          </div>
          </div>

          <br/>
					<div className="row nopadding-left">
					<div className="col-md-5 nopadding-left">
						<button type="submit" className="btn btn-primary">Ajouter la Ligue</button>
            </div>
					</div>

					<br/>
					<div className="row nopadding-left">
					<div className="col-md-9 nopadding-left">
						<p>* Le nom devrait comprendre une indication du lieu ou la ligue est jouée et 
						le nom de la ligue proprement dit.  Ne pas inclure d'informations liées à la saison, elles seront
						déterminées lorsque vous créerez vos saisons.</p>
          </div>
					</div>

					<br/>
				 </form>
			</div>
		);
	}
	
}

export default AddLeague;